var config = require("app/config"),
    utils  = require("enyo/utils");

module.exports = {
    /**
     * Loader promise
     *
     * @type  {Promise}
     * @private
     */
    promise: null,

    // Implementation
    // ----------------

    /**
     * Load Radiant MediaPlayer (we have to do things this way because it
     * doesn't play nice with CommonJS).
     *
     * @return  {Promise}  Resolves when player is loaded
     * @private
     */
    load: function() {
        var resolver,
            rejector,
            script;

        // Already loading or loaded
        if (this.promise) {
            return this.promise;
        }

        // New loading promise
        this.promise = new Promise(function(resolve, reject) {
            resolver = resolve;
            rejector = reject;
        });

        script         = document.createElement("script");
        script.id      = "radiant-media-player-" + utils.uid();
        script.src     = config.radiantMediaPlayer.pathToRmpFiles + "dist/rmp.min.js";
        script.onload  = resolver;
        script.onerror = rejector;

        document.head.appendChild(script);

        return this.promise;
    }
};
